<template>
  <v-container>
    <v-row xs12 class="mt-1">
      <v-col sm="2" md="2" offset-md="10">
        <v-fab-transition v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn
              v-on:click="showAddPropertyDialog=true"
              color="rgb(0, 188, 212)"
              dark
              fixed
              fab
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-fab-transition v-else>
          <v-btn
              v-on:click="showAddPropertyDialog=true"
              color="rgb(0, 188, 212)"
              dark
              fixed
              bottom
              right
              fab
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-col>
    </v-row>
    <v-row class="home" xs12>
      <v-col md="12" sm="12">
        <PropertyList/>
      </v-col>
    </v-row>
    <AddProperty :show="showAddPropertyDialog" @saved="add" @cancelled="showAddPropertyDialog=false"></AddProperty>
  </v-container>
</template>

<script>
import PropertyList from '@/components/PropertyList.vue';
import AddProperty from '../components/AddProperty';
import { authService } from '@/services/AuthService';

export default {
  name: 'Home',
  components: {
    AddProperty,
    PropertyList
  },
  data: function() {
    return {
      showAddPropertyDialog: false,
      authService: authService
    };
  },
  methods: {
    add: function() {
      this.showAddPropertyDialog = false;
    }
  }
};
</script>